import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="relative w-full h-[520px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20Korean%20manhwa%20inspired%20backdrop%2C%20soft%20orange%20and%20amber%20gradient%20tones%2C%20abstract%20artistic%20composition%20with%20gentle%20light%20leaks%2C%20dreamy%20ethereal%20mood%2C%20cozy%20reading%20atmosphere%2C%20digital%20art%20with%20painterly%20texture%2C%20warm%20sunset%20feel%2C%20no%20text&width=1600&height=900&seq=cta-bg-warm&orientation=landscape"
        alt="加入炮渣漫画"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white tracking-wide uppercase mb-6">
          立即加入炮渣漫画
        </h2>
        <p className="text-white/80 text-sm md:text-lg max-w-[520px] mb-10 leading-relaxed">
          海量韩国漫画等你来发现，每日更新不重样
          <br />
          注册即享个性化推荐，追漫从未如此简单
        </p>
        <Link
          to="/category/action"
          className="group relative inline-flex items-center bg-foreground-950 text-white font-medium text-sm px-8 py-4 rounded-full whitespace-nowrap transition-all hover:bg-foreground-800 cursor-pointer"
        >
          <span className="absolute -left-1 top-1/2 -translate-y-1/2 w-10 h-10 bg-accent-500 rounded-full flex items-center justify-center">
            <i className="ri-shopping-bag-line text-white text-sm"></i>
          </span>
          <span className="ml-5">立即免费阅读</span>
          <i className="ri-arrow-right-up-line ml-2 text-sm"></i>
        </Link>
      </div>
    </section>
  );
}